import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useLocation, useMatch } from 'react-router-dom';
import { appSetup, appLoadedSuccess, appReset } from './actions';
import { selectAppLoaded } from './selectors';
import ActiveGame from '../ActiveGame';
import Errors from '../Errors';
import Games from '../Games';
import Home from '../Home';
import Login from '../Login';
import ForgotPassword from '../PasswordReset/ForgotPassword';
import ResetPassword from '../PasswordReset/ResetPassword';
import MainMenu from '../MainMenu';
import Notices from '../Notices';
import Rules from '../Rules';
import Profile from '../Profile';
import Watch from '../Watch';
import CardLookup from '../CardLookup';
import DecksPage from '../DecksPage';
import cookieManager from '../services/cookieManager';

function App() {
  const dispatch = useDispatch();
  const appLoaded = useSelector(selectAppLoaded);
  const location = useLocation();
  // A game uses the whole screen; every other page has the header.
  const inGame = useMatch('/games/:id');

  // reset app when route changes
  useEffect(() => {
    dispatch(appReset());
  }, [location.pathname, dispatch]);

  // initialize token, or mark app as loaded so login can happen
  useEffect(() => {
    const accessToken = cookieManager.getAccessToken();

    if (accessToken) {
      dispatch(appSetup());
    } else {
      dispatch(appLoadedSuccess());
    }
  }, [appLoaded, dispatch]);

  if (!appLoaded) {
    return null;
  }

  return (
    <>
      {!inGame && <MainMenu />}

      <Errors />

      <Notices />

      <Routes>
        <Route path="/games/:id" element={<ActiveGame />} />
        <Route path="/games" element={<Games />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/watch/:id" element={<Watch />} />
        <Route path="/cards" element={<CardLookup />} />
        <Route path="/decks" element={<DecksPage />} />
        <Route path="/rules/text" element={<Rules />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  );
}

export default App;
